import { render } from "./province-item.vue?vue&type=template&id=aa9ebed0&scoped=true&ts=true"
import script from "./province-item.vue?vue&type=script&lang=ts"
export * from "./province-item.vue?vue&type=script&lang=ts"

import "./province-item.vue?vue&type=style&index=0&id=aa9ebed0&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa9ebed0"]])

export default __exports__